export default {
	section_banner: {
		title: {
			one: 'For The Mind Of The',
		},
		main_title: {
			one: 'Customer',
		},
		sub_title: {
			one: '& The',
			two: 'Consumer',
		},
		paragraph: {
			one: 'We can to protect our business using machine learning & protect both our customers assets and our consumers.',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Contact Sales Dept',
		},
	},

	question_sec: {
		label: 'Built For Your Needs',
		title: {
			one: 'Does Your Business Need A Highly Customizable',
			two: 'Commerce Solution?',
		},
		cta_buttons: {
			one: 'About Our Business',
		},
	},

	credit_system: {
		label: 'Safely Transaction',
		title: {
			one: 'Rich',
			two: 'Experience',
		},
		paragraph: {
			one: 'Please use the transaction safely through JPWorldPay, which was created based on the blockchain know-how that started from',
			two: 'the beginning of the blockchain being known.',
		},
	},

	credit_system_lt: {
		label: 'Confidence & Reliability',
		title: {
			one: 'Transaction',
			two: 'Safely',
		},
		paragraph:
			'With the world’s most secure blockchain, we can reach customers around the globe with confidence and reliability. JPWorldPay leverages advanced security and global accessibility to ensure smooth, borderless transactions. No matter where your customers are, you can connect with them securely and efficiently.',
		cta_buttons: {
			one: 'Get Started',
		},
	},

	credit_system_rt: {
		label: 'Defense Against Threats',
		title: {
			one: 'Fraud Detection',
			two: 'Technology',
		},
		paragraph:
			'Our fraud detection tools get smarter with each transaction, protecting you from existing and evolving threats. By analyzing transaction patterns in real time, JPWorldPay ensures proactive defense against threats.',
		cta_buttons: {
			one: 'Get Started',
		},
	},

	section_newsletter: {
		label: 'SUBSCRIBE NEWSLETTER',
		title: {
			one: 'Subscribe',
			two: '& Get A Latest Update',
		},
		description: {
			one: 'Subscribe us & recieve our offers and updates in your inbox directly.',
			two: 'Get in touch to learn how our JPWorldPay solution can increase your business.',
		},
		form: {
			placeholder: 'Email ID',
			button: 'SUBSCRIBE NOW',
		},
	},
};
